
export default {
  props: {
    redirect: { type: String, required: true },
    closeSearch: { type: Function, required: true },
    suggestions: { type: Array, required: true },
    currentQuery: { type: String, required: true },
    loading: { type: Boolean, required: true },
    isTrendingState: { type: Boolean, default: false },
  },
};
